import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QrCodeScannerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"qr_code_scanner"}/>
}
